<script setup lang="ts">
import LabelBase from '@/components/label/LabelBase.vue'
import PhIcon from '@/components/PhIcon.vue'
import type { ColorKey } from '@/types/tailwind'
import { bgColor500p25, textColor500 } from '@/globals/tailwind.ts'

// props & emit
withDefaults(
  defineProps<{
    title: string
    desc?: string
    color?: ColorKey
    icon?: string
    hideBorder?: boolean
  }>(),
  {
    color: 'blue',
    hideBorder: false,
  },
)
</script>

<template>
  <div
    :class="{
      'border-b border-dashed border-stone-200 dark:border-stone-700 transition-colors duration-150':
        !hideBorder,
    }"
    class="p-4 pt-6 space-y-4"
  >
    <div class="flex gap-4 mb-6">
      <div v-if="icon" class="block md:hidden">
        <div :class="[bgColor500p25[color], textColor500[color]]" class="p-2 rounded-xl">
          <ph-icon :name="icon" :size="32"></ph-icon>
        </div>
      </div>
      <div>
        <label-base size="xl" class="block font-bold capitalize">{{ title }}</label-base>
        <label-base v-if="desc" color="stone" size="sm" class="block first-letter:uppercase">{{
          desc
        }}</label-base>
      </div>
    </div>
    <div class="flex md:gap-6">
      <div v-if="icon" class="hidden md:block">
        <div :class="[bgColor500p25[color], textColor500[color]]" class="p-4 rounded-2xl">
          <ph-icon :name="icon" :size="32"></ph-icon>
        </div>
      </div>
      <div class="w-full">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
